// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"b7fd2641","147":"958a63f6","171":"87d94d6b","374":"5346a89f","453":"97347aa2","507":"d7dcc740","801":"e7d36d38","818":"aeb12dce"}[chunkId] + ".chunk.js";
};